/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Theme_SoftInputs */

const en_profile_theme_soft = /** @type {(inputs: Profile_Theme_SoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soft Mode`)
};

const pt_br2_profile_theme_soft = /** @type {(inputs: Profile_Theme_SoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo Café`)
};

/**
* | output |
* | --- |
* | "Soft Mode" |
*
* @param {Profile_Theme_SoftInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const profile_theme_soft = /** @type {((inputs?: Profile_Theme_SoftInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Theme_SoftInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_theme_soft(inputs)
	return pt_br2_profile_theme_soft(inputs)
});